import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: string | null = localStorage.getItem('DBAuthTkn');
    console.log("Sesion url: " + request.url);
    const modifiedReq = request.clone({ 
      headers: request.headers.set('Auth-token', (token!=null) ? token : ''),
    });

    return next.handle(modifiedReq);
  }
}
